









































import ripple from "./ripple.vue";
import tooltip from "./tooltip.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

import {diff_match_patch} from "diff-match-patch"
import { Func } from "continuation-local-storage";
const dmp = new diff_match_patch();

export type SearchRes = {
    resultType: "worker" | "job" | "client",
    resultName: string,
    resultID: string,
    resultClient?:string,
};
export type SearchFunc = (query?: string) => SearchRes[];

@Component({
    components: {
        ripple,
        tooltip
    }
})
export default class Search extends Vue {
    @Prop({}) maxResults: number;
    @Prop({}) large: boolean;

    @Prop({}) scope:string;
    results: {
        lowOrder: SearchRes[],
        highOrder: SearchRes[],
    } = null;

    @Prop({}) maxViewport: boolean;
    @Prop({}) elemToMaximise: HTMLElement;
    @Prop({}) getResults: SearchFunc;

    @Prop({default: true}) caseInsensitive: boolean;

    isActive:boolean = false;

    searchQuery: string = "";

    styleToMaximise:{
        top:'0';
        left:'0';
        right:'0';
        height: '100%';
        position: "absolute";
    }

    focusing(){
        this.isActive = true;
        if(this.maxViewport){
            if(this.elemToMaximise){
                // this.elemToMaximise.style = (this.styleToMaximise as CSSStyleDeclaration);
            }
        }
    }
    unfocusing(){
        this.isActive = false;
    }

    async searchBegin() {
        if(this.searchQuery.trim() == '') return;
        if(this.searchQuery.length < 2) return;

        if(this.scope == "global"){
            this.results = this.containsCheck(await this.getResults(this.searchQuery), this.searchQuery);
        }
    }

    focusInput(){
        (this.$refs.input as HTMLElement).focus();
    }

    containsCheck(arr: SearchRes[],check:string){
        let results = {
            highOrder:[],
            lowOrder:[],
        };

        if(this.caseInsensitive) {
            check = check.toLowerCase();
        }

        for(let i=0; i<arr.length; i++){
            if(this.caseInsensitive ? arr[i].resultName.toLowerCase().includes(check) : arr[i].resultName.includes(check)){
                results.highOrder.push(arr[i]);
            }
            else{
                results.lowOrder.push(arr[i]);
            }

            if(results.highOrder.length > this.maxResults) {
                results.lowOrder.splice(0,results.lowOrder.length)
                return results;
            }
        }

        results.lowOrder.sort((a,b) => {
            let d1,d2;
            if(this.caseInsensitive) {
                d1 = dmp.diff_main(check,a.resultName.toLowerCase());
                d2 = dmp.diff_main(check,b.resultName.toLowerCase());
            }
            else {
                d1 = dmp.diff_main(check,a.resultName);
                d2 = dmp.diff_main(check,b.resultName);
            }
            return dmp.diff_levenshtein(d1) - dmp.diff_levenshtein(d2);
        })

        let maxLowOrderResults = this.maxResults - results.highOrder.length;
        results.lowOrder.splice(maxLowOrderResults,results.lowOrder.length - maxLowOrderResults);

        return results;
    }

    open(result){
        switch(result.resultType){
            case "job":{
                this.redirect("jobView",{jobID:result.resultID});
                break;
            }
            case "worker":{
                this.redirect("admin-staff",{userID:result.resultID});
                break;
            }
            case "client":{
                this.redirect("admin-clients",{name:result.resultName});
                break;
            }
        }

        this.unfocusing();
    }

    redirect(route,parameters?){
        this.$router.push({ name: route, params: parameters});
    };

}

